import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-761613e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_4 = { class: "d-flex align-items-center mb-4 bg-search p-4 rounded-4" }
const _hoisted_5 = { class: "d-flex col-lg-7 align-items-center me-4" }
const _hoisted_6 = { class: "me-3 text-nowrap" }
const _hoisted_7 = ["onKeyup", "placeholder", "maxlength"]
const _hoisted_8 = { class: "d-lg-flex justify-content-end" }
const _hoisted_9 = { class: "d-flex justify-content-center mb-3" }
const _hoisted_10 = { class: "d-flex justify-content-center mb-3" }
const _hoisted_11 = { class: "d-flex justify-content-center mb-3" }
const _hoisted_12 = { class: "d-flex justify-content-center mb-3" }
const _hoisted_13 = { class: "d-lg-flex" }
const _hoisted_14 = { class: "me-lg-4 mb-lg-0 mb-3" }
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table table-borderless w-max-content" }
const _hoisted_17 = { class: "align-middle text-center" }
const _hoisted_18 = { class: "rounded-top" }
const _hoisted_19 = ["checked", "onChange"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_26 = { class: "text-break" }
const _hoisted_27 = {
  key: 1,
  class: "status d-flex justify-content-center fw-bold text-white align-items-center mx-auto"
}
const _hoisted_28 = {
  key: 2,
  class: "status px-1 py-1 fw-bold text-white mx-auto"
}
const _hoisted_29 = {
  key: 0,
  class: "text-center fw-bold"
}
const _hoisted_30 = {
  key: 1,
  class: "text-center fw-bold"
}
const _hoisted_31 = { class: "d-lg-flex" }
const _hoisted_32 = { class: "me-lg-4 mb-lg-0 mb-3" }

import { ref, watchEffect, computed, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import Button from '@/components/button/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import Pagination from '@/components/pagination/index.vue'
import CellSort from '@/components/sort-field-table/index.vue'
import ConfirmModalApprove from '@/views/community-admin/approval/waiting-user-approve/components/ConfirmModalApprove.vue'
import SuccessModal from '@/views/community-admin/approval/waiting-user-approve/components/SuccessModal.vue'
import ModalConfirmCsv from '@/views/community-admin/user-management/alumni-user/table-users/components/ModalConfirmCsv.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import { MAX_LENGTH_USER_NAME_SEARCH } from '@/constants/number'
import { translate } from '@/languages/i18n'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { COMMUNITY_ALUMNUS_CANDIDATES_STORE, CONVERSATIONS_STORE } from '@/store/constants'
import Loading from '@/components/loading/index.vue'
import TotalRecords from '@/components/total-records/index.vue'
import communityAlumnusServices from '@/services/community-alumnus.services'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'
import _ from 'lodash'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()

const dataCandidates = computed(() => store.getters[COMMUNITY_ALUMNUS_CANDIDATES_STORE.GETTERS.GET_LIST_USERS])
const dataDetail = computed(() => store.getters[COMMUNITY_ALUMNUS_CANDIDATES_STORE.GETTERS.GET_CANDIDATE_DETAIL]?.error)
const listManagementNo = computed(() => store.getters[CONVERSATIONS_STORE.GETTERS.LIST_MANAGEMENT_NO]?.candidates)
const allRecords = computed(() => store.getters[CONVERSATIONS_STORE.GETTERS.GET_ALL_DATA]?.candidates)

const useQueryData = ({
  keyword,
  page,
  page_of_number,
  created_at,
  management_no,
  email,
  customer_name,
}: {
  keyword?: string
  page?: number | string
  page_of_number?: number | string
  created_at?: string
  management_no?: string
  email?: string
  customer_name?: string
}) => {
  store.dispatch(COMMUNITY_ALUMNUS_CANDIDATES_STORE.ACTIONS.SET_USERS_CANDIDATES, {
    id: route.params?.id,
    params: {
      keyword: keyword || '',
      page: page || 1,
      page_of_number: page_of_number || 30,
      created_at: created_at,
      management_no: management_no,
      email: email,
      customer_name: customer_name,
    },
  })
}

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('almunaiParManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('CI10breadcrumb'),
    to: '',
    active: true,
  },
]

const keyword = ref('')
const data = ref()
const typeModal = ref<{ type: string; title: string }>({ type: '', title: '' })
const isCheckedAll = ref<boolean>(false)
const isFilter = ref<boolean>(false)
const typeError = ref<string>('')

watchEffect(() => {
  data.value = dataCandidates.value?.listUserCandidates?.map((item: any) => {
    return { ...item }
  })
})

onMounted(async () => {
  await store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, { typeData: 'candidates', type: 'unCheckAll', data: [] })
})

const handleCheckID = (id: string) => {
  const dataCheck = data.value.filter((record) => record.management_no === id)
  const payload = {
    typeData: 'candidates',
    data: dataCheck[0],
  }
  if (dataCheck?.length > 0) store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_LIST_MANAGEMENT_NO, payload)

  if (allRecords.value?.length > 0 && listManagementNo.value?.length === allRecords.value?.length) {
    isCheckedAll.value = true
  } else {
    isCheckedAll.value = listManagementNo.value?.length === dataCandidates.value?.total_records
  }
}

const handleSearchKeyword = () => {
  isFilter.value = true
  useQueryData({ ...route.query, keyword: keyword.value, page: 1 })
  router.replace({ path: route.path, query: { ...route.query, page: 1, keyword: keyword.value } })
  isCheckedAll.value = false
  store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, { typeData: 'candidates', type: 'unCheckAll', data: [] })
}

const loadingCheckAll = ref<boolean>(false)
const handleCheckAll = async (): void => {
  if (isCheckedAll.value) {
    loadingCheckAll.value = true
    await store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_ALL_DATA, {
      id: route.params?.id,
      data: {
        keyword: keyword.value,
      },
      typeData: 'candidates',
    })
    await useQueryData({ ...route.query, page_of_number: route.query?.page_of_number || 30 })
    const payload = {
      typeData: 'candidates',
      type: 'checkAll',
      data: allRecords.value,
    }
    await store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, payload)
    loadingCheckAll.value = false
  } else {
    await store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, { typeData: 'candidates', type: 'unCheckAll', data: [] })
  }
}

const getTypeError = (errorType: string): void => {
  typeError.value = errorType
}

const transitDetail = (ID: string) => {
  router.push(`/community/communities/${route.params?.id}/alumnus_candidates_waiting_approval/edit?management_no=${ID}`)
}

const checkModalType = (type: string): void => {
  if (type === 'approve') {
    typeModal.value = {
      type: 'approve',
      title: translate('approveList'),
    }
  }
  if (type === 'reject') {
    typeModal.value = {
      type: 'reject',
      title: translate('rejectList'),
    }
  }
  if (type === 'delete') {
    typeModal.value = {
      type: 'delete',
      title: translate('deleteList'),
    }
  }
}

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

watch(
  () => route.query,
  () => {
    if (route.path.match('/alumnus_candidates_waiting_approval')) {
      useQueryData({ ...route.query, page_of_number: route.query?.page_of_number || 30 })
    }
  },
  { immediate: true }
)

watch(
  () => dataCandidates.value?.total_records,
  () => {
    if (dataCandidates.value?.total_records === 0) isCheckedAll.value = false
    store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, { typeData: 'candidates', type: 'unCheckAll', data: [] })
  },
  { immediate: true }
)

watch(
  () => listManagementNo.value,
  () => {
    if (listManagementNo.value?.length === 0) isCheckedAll.value = false
  },
  { immediate: true }
)
onMounted(() => {
  if (Object.keys(route.query).length === 0 && router.currentRoute.value.path.match('/alumnus_candidates_waiting_approval')?.length) {
    router.replace({ path: route.path, query: { management_no: 'desc' } })
  }
})

watch(
  () => route.path,
  () => {
    store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, { typeData: 'alumni', type: 'unCheckAll', data: [] })
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('CI10breadcrumb')), 1),
      (_unref(dataDetail))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(translate)('CC10errorUserInfor')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(translate)('username')), 1),
            _withDirectives(_createElementVNode("input", {
              onKeyup: _withKeys(handleSearchKeyword, ["enter"]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
              type: "text",
              placeholder: _unref(translate)('placeholder'),
              maxlength: _unref(MAX_LENGTH_USER_NAME_SEARCH),
              class: "form-control w-100"
            }, null, 40, _hoisted_7), [
              [
                _vModelText,
                keyword.value,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createVNode(Button, {
            title: _unref(translate)('CI10search'),
            type: 'secondary',
            size: 'small',
            onClick: handleSearchKeyword
          }, null, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Button, {
              title: "CSVダウンロード",
              type: "secondary",
              disabled: _unref(listManagementNo)?.length === 0,
              "class-name": "me-lg-4",
              dataBsToggle: "modal",
              dataBsTarget: "#modalConfirmCsvAlmunus"
            }, null, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(Button, {
              title: _unref(translate)('approveList'),
              type: 'secondary',
              disabled: _unref(listManagementNo)?.length === 0,
              dataBsToggle: 'modal',
              dataBsTarget: '#modalConfirmActionCandidates',
              onClick: () => checkModalType('approve')
            }, null, 8, ["title", "disabled", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(Button, {
              title: _unref(translate)('rejectList'),
              type: 'secondary',
              disabled: _unref(listManagementNo)?.length === 0,
              "class-name": "mx-lg-4",
              dataBsToggle: 'modal',
              dataBsTarget: '#modalConfirmActionCandidates',
              onClick: () => checkModalType('reject')
            }, null, 8, ["title", "disabled", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(Button, {
              title: _unref(translate)('deleteList'),
              type: 'secondary',
              disabled: _unref(listManagementNo)?.length === 0,
              dataBsToggle: 'modal',
              dataBsTarget: '#modalConfirmActionCandidates',
              onClick: () => checkModalType('delete')
            }, null, 8, ["title", "disabled", "onClick"])
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(TotalRecords, {
            totalRecords: _unref(dataCandidates)?.total_records,
            totalChecked: _unref(listManagementNo)?.length,
            isChecked: true
          }, null, 8, ["totalRecords", "totalChecked"]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(Pagination, {
                totalDataOfPage: _unref(dataCandidates)?.listUserCandidates?.length,
                totalPage: _unref(dataCandidates)?.total_pages
              }, null, 8, ["totalDataOfPage", "totalPage"])
            ]),
            _createVNode(SelectCustom, {
              options: dataSelectRecordPerPage.value,
              keyName: 'page_of_number'
            }, null, 8, ["options"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("table", _hoisted_16, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_17, [
                  _createElementVNode("th", _hoisted_18, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input cursor-pointer",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isCheckedAll).value = $event)),
                        value: "",
                        id: "flexCheckDefault",
                        onChange: handleCheckAll
                      }, null, 544), [
                        [_vModelCheckbox, isCheckedAll.value]
                      ])
                    ]),
                    _createElementVNode("div", null, _toDisplayString(_unref(translate)('selectAll')), 1)
                  ]),
                  _createElementVNode("th", null, [
                    _createVNode(CellSort, {
                      title: _unref(translate)('managementNo'),
                      keyName: 'management_no'
                    }, null, 8, ["title"])
                  ]),
                  _createElementVNode("th", null, [
                    _createVNode(CellSort, {
                      title: _unref(translate)('CI10titleName'),
                      keyName: 'customer_name'
                    }, null, 8, ["title"])
                  ]),
                  _createElementVNode("th", null, [
                    _createVNode(CellSort, {
                      title: _unref(translate)('email'),
                      keyName: 'email'
                    }, null, 8, ["title"])
                  ]),
                  _createElementVNode("th", null, [
                    _createVNode(CellSort, {
                      title: _unref(translate)('CI10registrationDate'),
                      keyName: 'created_at'
                    }, null, 8, ["title"])
                  ]),
                  _createElementVNode("th", null, _toDisplayString(_unref(translate)('CI10RegistrationRoute')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: _normalizeClass(["align-middle text-center cursor-pointer", { rowEven: index % 2 === 0, rowDisabled: item.examinated === false, rowChecked: _unref(_).map(_unref(listManagementNo), 'management_no').includes(item.management_no) }]),
                    key: index
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("input", {
                        class: "form-check-input cursor-pointer",
                        type: "checkbox",
                        checked: _unref(_).map(_unref(listManagementNo), 'management_no').includes(item.management_no),
                        onChange: ($event: any) => (handleCheckID(item.management_no)),
                        id: "flexCheckDefault"
                      }, null, 40, _hoisted_19)
                    ]),
                    _createElementVNode("td", {
                      onClick: () => transitDetail(item?.management_no)
                    }, _toDisplayString(item.management_no), 9, _hoisted_20),
                    _createElementVNode("td", {
                      class: "text-break",
                      onClick: () => transitDetail(item?.management_no)
                    }, _toDisplayString(item.family_name + ' ' + item.given_name), 9, _hoisted_21),
                    _createElementVNode("td", {
                      class: "text-break w-25",
                      onClick: () => transitDetail(item?.management_no)
                    }, _toDisplayString(item.email || '-'), 9, _hoisted_22),
                    _createElementVNode("td", {
                      onClick: () => transitDetail(item?.management_no)
                    }, _toDisplayString(item.created_at ? _unref(ConvertFromLocalTime)(item.created_at) : '-'), 9, _hoisted_23),
                    _createElementVNode("td", {
                      onClick: () => transitDetail(item?.management_no)
                    }, [
                      (item.invited_community_management.user_type !== 3 && item.invited_route === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(UserAliasIcon, {
                              userType: item.invited_community_management.user_type
                            }, null, 8, ["userType"]),
                            _createElementVNode("span", _hoisted_26, _toDisplayString(item.invited_community_management.family_name + ' ' + item.invited_community_management.given_name), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (item.invited_community_management.user_type === 3 && item.invited_route === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(translate)('CD40management')), 1))
                        : _createCommentVNode("", true),
                      (item.invited_route !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(item.invited_route_name), 1))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_24)
                  ], 2))
                }), 128))
              ])
            ]),
            (_unref(dataCandidates)?.listUserCandidates?.length === 0 && isFilter.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(translate)('CI10noDataSearch')), 1))
              : _createCommentVNode("", true),
            (_unref(dataCandidates)?.listUserCandidates?.length === 0 && !isFilter.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(translate)('CC10noData')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createVNode(Pagination, {
                totalDataOfPage: _unref(dataCandidates)?.listUserCandidates?.length,
                totalPage: _unref(dataCandidates)?.total_pages
              }, null, 8, ["totalDataOfPage", "totalPage"])
            ]),
            _createVNode(SelectCustom, {
              options: dataSelectRecordPerPage.value,
              keyName: 'page_of_number'
            }, null, 8, ["options"])
          ])
        ])
      ])
    ]),
    _createVNode(ConfirmModalApprove, {
      data: _unref(listManagementNo),
      typeModal: typeModal.value,
      reload: () => useQueryData({ ..._unref(route).query }),
      getTypeError: getTypeError
    }, null, 8, ["data", "typeModal", "reload"]),
    _createVNode(SuccessModal, {
      typeModal: typeModal.value,
      data: data.value,
      reload: () => useQueryData({ ..._unref(route).query }),
      typeError: typeError.value
    }, null, 8, ["typeModal", "data", "reload", "typeError"]),
    _createVNode(ModalConfirmCsv, {
      isCandidate: true,
      data: _unref(listManagementNo),
      reload: () => useQueryData({ ..._unref(route).query, page_of_number: _unref(route).query?.page_of_number || 30 })
    }, null, 8, ["data", "reload"]),
    _createVNode(Loading, {
      loading: _unref(dataCandidates)?.loading || loadingCheckAll.value
    }, null, 8, ["loading"])
  ], 64))
}
}

})